import { SchrankSectionHeader } from '../components/schrank/SchrankSectionHeader';
// SchrankAnsichtPage - Reine Read-Only-Ansicht für alle Mitarbeiter
import React from 'react';
import MainLayout from '../components/layout/MainLayout';
import { SchrankViewer } from '../components/schrank/SchrankViewer';

export function SchrankAnsichtPage() {
  return (
    <MainLayout>
      <div className="schrank-workspace" data-testid="schrank-ansicht-page">
        <SchrankSectionHeader title="Ansicht" description="Räume und Schrankbelegungen im Überblick." />
        <SchrankViewer mode="view" canAssign={false} />
      </div>
    </MainLayout>
  );
}

export default SchrankAnsichtPage;
